/* src/services/OperatorService.js */
import apiClient from './api'

export const OperatorService = {
  mapFromApi(data) {

    const nome = data.first_name || '';
    const cognome = data.last_name || '';
    const fullName = `${nome} ${cognome}`.trim();
    let parsedSkills = Array.isArray(data.skills) ? data.skills : [];
    const baseURL = apiClient.defaults.baseURL.replace(/\/api\/?$/, '')

    let avatarUrl = ''

    if (data.avatar) {
    
        if (data.avatar.startsWith('http')) {
    
            avatarUrl = data.avatar
        } 
        else {
        
            const cleanPath = data.avatar.replace(/^\/+/, '')

            if (cleanPath.startsWith('media/')) {

                avatarUrl = `${baseURL}/${cleanPath}`
            } 
            else {

                avatarUrl = `${baseURL}/media/${cleanPath}`
            }
        }
    }

    return {
      id: data.id,
      name: fullName || `Operatore ${data.id}`,
      qualifica: data.job_title || '',
      bio: data.bio || '',
      skills: parsedSkills,
      isActive: data.is_active ?? true,
      avatar: avatarUrl
    }
  },

  mapToApi(operator) {

    const skillIds = operator.skills
      .filter(s => s && (s.id || typeof s === 'number'))
      .map(s => (typeof s === 'object' ? s.id : s));

    return {
      name: operator.name,
      job_title: operator.qualifica,
      bio: operator.bio,
      skills: skillIds,
      is_active: operator.isActive,
      avatar: operator.avatar,
    }
  },

  async fetchSkills() {
    const response = await apiClient.get('operators/skills/')
    return Array.isArray(response.data) ? response.data : (response.data.results || [])
  },

  async getAll() {
    const response = await apiClient.get('operators/list/')
    const data = Array.isArray(response.data) ? response.data : (response.data.results || [])
    return data.map(item => this.mapFromApi(item))
  },

  async create(operator) {
    return await apiClient.post('operators/list/', this.mapToApi(operator))
  },

  async update(id, operator) {
    return await apiClient.put(`operators/list/${id}/`, this.mapToApi(operator))
  },

  async updateSchedule(operatorId, shifts) {
    const payload = {
      operator: operatorId,
      shifts: shifts.map(s => ({
        day_of_week: s.day_index, // Assicurati di passare l'indice 0-6
        start_time: `${s.start}:00`,
        end_time: `${s.end}:00`,
        is_working: !!s.isWorking
      }))
    }
    return await apiClient.put(`operators/list/${operatorId}/update-schedule/`, payload)
  },
  
  async delete(id) { return await apiClient.delete(`operators/list/${id}/`) },
  async getSchedules() { return (await apiClient.get('operators/list/schedules/')).data }
}